<h3 class="title" mat-dialog-title>{{ data.title | translate }}</h3>

<mat-dialog-content>
  <h6 class="message">{{ data.message | translate }}</h6>
</mat-dialog-content>

<mat-dialog-actions class="button-container" [align]="'end'">
  <button mat-button [mat-dialog-close]="false">
    {{ data.cancel | translate }}
  </button>
  <button mat-raised-button color="primary" [mat-dialog-close]="true">
    {{ data.confirm | translate }}
  </button>
</mat-dialog-actions>
